import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Login from './pages/Login';
import SetPassword from './pages/SetPassword';
import AdminDashboard from './pages/AdminDashboard';
import BuyerDashboard from './pages/BuyerDashboard';
import SellerDashboard from './pages/SellerDashboard';
import AllProjects from './pages/AllProjects';
import AdminUsers from './pages/AdminUsers';
import NotarDashboard from './pages/NotarDashboard';
import { API_URL } from './config';

axios.defaults.baseURL = API_URL;
axios.defaults.withCredentials = true;

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/api/auth/me')
      .then(res => setUser(res.data.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={styles.loading}>Laden...</div>;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={
          user ? <Navigate to="/dashboard" /> : <Login setUser={setUser} />
        } />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/dashboard" element={
          !user ? <Navigate to="/login" /> :
          user.role === 'admin' ? <AdminDashboard user={user} setUser={setUser} /> :
          user.role === 'buyer' ? <BuyerDashboard user={user} setUser={setUser} /> :
          user.role === 'notar' ? <NotarDashboard user={user} setUser={setUser} /> :
          <SellerDashboard user={user} setUser={setUser} />
        } />
        <Route path="/all-projects" element={
          !user ? <Navigate to="/login" /> :
          user.role === 'admin' && user.is_superadmin ? <AllProjects user={user} onBack={() => window.location.href = '/dashboard'} /> :
          <Navigate to="/dashboard" />
        } />
        <Route path="/admin-users" element={
          !user ? <Navigate to="/login" /> :
          user.role === 'admin' && user.is_superadmin ? <AdminUsers user={user} onBack={() => window.location.href = '/dashboard'} /> :
          <Navigate to="/dashboard" />
        } />
        <Route path="*" element={<Navigate to={user ? "/dashboard" : "/login"} />} />
      </Routes>
    </BrowserRouter>
  );
}

const styles = {
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '18px',
  }
};

export default App;